import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Header from "@/components/Header";
import StickyBar from "@/components/StickyBar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import LocationsIndex from "@/pages/LocationsIndex";
import CityPage from "@/pages/CityPage";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightArticle from "@/pages/InsightArticle";
import Contact from "@/pages/Contact";
import WelshHome from "@/pages/WelshHome";
import WelshServices from "@/pages/WelshServices";
import WelshLocations from "@/pages/WelshLocations";
import WelshCityPage from "@/pages/WelshCityPage";
import WelshServicePage from "@/pages/WelshServicePage";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname, search, hash } = useLocation();
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  if (clean !== pathname) return <Navigate to={clean + search + hash} replace />;
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#0A0C10] text-[#F1F2F4]">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <main className="pb-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/locations" element={<LocationsIndex />} />
              <Route path="/locations/:slug" element={<CityPage />} />
              <Route path="/insights" element={<InsightsIndex />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cy" element={<WelshHome />} />
              <Route path="/cy/gwasanaethau" element={<WelshServices />} />
              <Route path="/cy/gwasanaethau/:slug" element={<WelshServicePage />} />
              <Route path="/cy/lleoliadau" element={<WelshLocations />} />
              <Route path="/cy/lleoliadau/:slug" element={<WelshCityPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <StickyBar />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
